export const baseURL =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:8084'

export const baseCDNURL = process.env.REACT_APP_CDN_URL || baseURL

export const baseWSURL = process.env.REACT_APP_BACKEND_WS_URL || baseURL
